import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { Logo, Input, NextStepButton } from "components";
import { UPDATE_INPUT, MOVE_TAB, SINGLE_INVOICE_AUTOFILL_RESET } from "actions";

class SingleInvoiceCompany extends Component {
  componentDidMount() {
    this.props.reset();
  }
  moveToNextTab = () => {
    this.props.moveToNextTab();
  };
  updateInput = data => {
    this.props.updateInput(data);
    this.props.reset();
  };
  render() {
    const props = this.props;
    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <div className="form_content">
              <div className="form_content">
                <div className="fields_container">
                  <div className={classNames("field_block field_block--fill", {})}>
                    <label>{props.domain.Strings.tabSingleInvoiceCompanyNameLabel}</label>
                    <Input value={props.singleInvoiceCompanyName} onChange={this.updateInput} name="singleInvoiceCompanyName" />
                  </div>

                  <NextStepButton text={props.singleInvoiceCompanyTryAgain ? props.domain.Strings.tabSingleInvoiceCompanyNextBtnTryAgain : props.domain.Strings.tabSingleInvoiceCompanyNextBtn} onClick={this.moveToNextTab} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) => dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab }),
    reset: () => dispatch({ type: SINGLE_INVOICE_AUTOFILL_RESET })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleInvoiceCompany);
